mutation CreateEventChatOverlay(
  $eventId: ID!
  $name: String!
  $twitchChatChannels: [String!]!
  $youtubeChatChannels: [String!]
  $textShadow: String
  $showBadges: Boolean
  $showChannelPills: Boolean
  $usernameFontSize: Int
  $usernameLineHeight: Int
  $messageFontSize: Int
  $messageLineHeight: Int
  $messageFontWeight: Int
  $usernameFontWeight: Int
  $imageScale: Int
  $messageColor: String
  $blockedWords: [String!]
  $fontFamily: String
  $youtubeSourceEnabled: Boolean
  $chatDelayMs: Int
  $show7tvEmotes: Boolean
  $showBttvEmotes: Boolean
  $showFfzEmotes: Boolean
  $showYouTubeProfilePictures: Boolean
) {
  chat: StreamToolsCreateEventChatOverlay(
    eventId: $eventId
    name: $name
    twitchChatChannels: $twitchChatChannels
    youtubeChatChannels: $youtubeChatChannels
    textShadow: $textShadow
    showBadges: $showBadges
    showChannelPills: $showChannelPills
    usernameFontSize: $usernameFontSize
    usernameLineHeight: $usernameLineHeight
    messageFontSize: $messageFontSize
    messageLineHeight: $messageLineHeight
    messageFontWeight: $messageFontWeight
    usernameFontWeight: $usernameFontWeight
    imageScale: $imageScale
    messageColor: $messageColor
    blockedWords: $blockedWords
    fontFamily: $fontFamily
    youtubeSourceEnabled: $youtubeSourceEnabled
    chatDelayMs: $chatDelayMs
    show7tvEmotes: $show7tvEmotes
    showBttvEmotes: $showBttvEmotes
    showFfzEmotes: $showFfzEmotes
    showYouTubeProfilePictures: $showYouTubeProfilePictures
  ) {
    chatId
    eventId
    name
    twitchChatChannels
    showTextShadow
    textShadow
    showBadges
    showChannelPills
    usernameFontSize
    usernameLineHeight
    messageFontSize
    messageLineHeight
    messageFontWeight
    usernameFontWeight
    imageScale
    messageColor
    blockedWords
    fontFamily
    youtubeSourceEnabled
    youtubeChatChannels
    chatDelayMs
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    showYouTubeProfilePictures
    createdAt
  }
}
